import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

/** Performance Max in the Gmail inbox (desktop), variant 2: a single ad row with a small landscape thumbnail, "Ad · Valamar" and the headline - description line. No open state. */
@Component({
  selector: 'app-pmax-gmail-desktop-02',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './gmail-desktop-02.component.html',
  styleUrl: './gmail-desktop-02.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PmaxGmailDesktop02PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** The uploaded creative matching this set's 1.91:1 landscape format, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  /** This placement's creative slot is the 1.91:1 landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  get headline(): string {
    return this.data.headlines[0] || 'Your headline appears here';
  }

  get description(): string {
    return this.data.descriptions[0] || 'Your description appears here';
  }
}
